import { render, staticRenderFns } from "./AreaPolitics.vue?vue&type=template&id=1ee6b5c0&"
import script from "./AreaPolitics.vue?vue&type=script&lang=js&"
export * from "./AreaPolitics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports